import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { map, Observable } from 'rxjs';
import { IRecipient } from '../../state/notification/notification.state';


// Create/Modify
export interface ITelegramMetadata {
  id?: string
  chat_id: string
}

export interface IWhatsappMetadata {
  id?: string
  phone_number: string
}

export interface IModifyRecipient {
  id?: string
  name: string
  comms_type: string
  site_ids: string[]
  metadata: ITelegramMetadata | IWhatsappMetadata
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private httpClient = inject(HttpClient)
  
  readonly endpoints = {
    getRecipients: `${environment.apiUrl}/comms-recipients`,
    createRecipients: `${environment.apiUrl}/comms-recipients`,
    editRecipients: `${environment.apiUrl}/comms-recipients`,
    deleteRecpients: `${environment.apiUrl}/comms-recipient/delete`,
    sendNotification: `${environment.apiUrl}/alert/notification/send`

  };

  getRecipients(organisationId: string): Observable<IRecipient[]> {
    return this.httpClient.get<IRecipient[]>(this.endpoints.getRecipients.replace("{0}", organisationId));
  }

  sendNotification(recipientIds: string[], alertIds: string[]) {
    return this.httpClient.post<any>(this.endpoints.sendNotification, {
      'recipient_ids': recipientIds,
      'alert_ids': alertIds,
    })
  }

  deleteRecipient(recipient: IRecipient) {
    let body = {
      "ids": [recipient.id]
    }
    return this.httpClient.post(this.endpoints.deleteRecpients, body);
  }

  createRecipient(recipient: IModifyRecipient): Observable<IRecipient> {
    
    const {id, ...request} = recipient
    {
      const {id, ...metadata} = recipient.metadata
      request.metadata = metadata
    }
    let body = [request]
    return this.httpClient.post<IRecipient[]>(this.endpoints.createRecipients, body).pipe(
      map(e => e[0])
    );
  }

  updateRecipient(recipient: IModifyRecipient): Observable<IRecipient> {
    let body = [recipient]
    return this.httpClient.put<IRecipient[]>(this.endpoints.editRecipients, body).pipe(
      map(e => e[0])
    );
  }
}
